import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import parse from 'html-react-parser'
import {Image} from '@learningblocks/storybook-components';
import {CloseButton} from '@learningblocks/storybook-components';
import style from './style.module.scss';
import style1 from '../style.module.scss';

export function GlossaryDetails(props) {
  return (
    <div className={style.detailsBlock}>
      {/*<CloseButton
        close={props.closeGlossary}
        className={style1.glossary_right_closeButton}
      />*/}
      <Image src={props.image} alt={props.title} />
      <h4><ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.title}</ReactMarkdown></h4>
      <div><ReactMarkdown rehypePlugins={[rehypeRaw]} >{props.description.replace("\\_", "_")}</ReactMarkdown></div>
    </div>
  );
}

GlossaryDetails.propTypes = {
  /**
   * Description of the option
   */
  description: PropTypes.string.isRequired,
  /**
   * Unique id for the option
   */
  id: PropTypes.number,
  /**
   * Image of the option
   */
  image: PropTypes.string.isRequired,
  /**
   * title of the option
   */
  title: PropTypes.string.isRequired,
};

GlossaryDetails.defaultProps = {
  description: '',
  id: 0,
  image: '',
  title: '',
};
